<template name="添加测量点二级弹框">
  <basic-card padding hideHeader :hasMore="showMore">
    <avue-crud
      :key="tableKey"
      :option="option"
      :data="data"
      :page="page"
      v-model="form"
      v-model:search="search"
      :table-loading="scopeLoading"
      ref="crud"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template #nameOrIds-search="{ row }">
        <CompSearch :placeholder="Lang.Text.modelSearchPointIds"
          v-model="search.nameOrIds"
          @change=" (val) => { this.onLoad(this.page, this.search) }"
          >
        </CompSearch>
      </template>
    </avue-crud>
  </basic-card>
  
</template>

<script>
import {
  getPage,
  getDetail,
  submit,
  remove,
} from '@/api/gateway/measurementPoint';
import { mapGetters } from 'vuex';
import { getLanguage, Lang } from '@/lang/lang';
import CompSearch from '@/components/comp-search/index.vue'

export default {
  name: 'SelectMeasurementPoint',
  props: {
    selectedPoints: {
      type: Array,
      default() {
        return [];
      },
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CompSearch,
  },
  data() {
    return {
      currentLangKey: this.language,
      tableKey: 0,
      form: {},
      itemId: '',
      operation: 'add',
      selectionList: [],
      query: {},
      search: {},
      showAddMeasurementPoint: false,
      loading: true,
      showMore: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      drawerVisible: false,
      direction: 'rtl',
      scopeLoading: false,
      scopeMenuId: 0,
      scopeMenuName: this.Lang.label.menu,
      menu: true,
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        tip: false,
        searchShow: true,
        searchSpan: 12,
        searchMenuSpan: 6,
        searchLabelWidth: 'auto',
        gutter: 20,
        border: true,
        index: true,
        emptyBtn: false,
        searchBtn: false,
        border: false, // 关键
        menuWidth: 146, // 操作列宽
        addBtn: true, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        selection: true,
        menuWidth: 116,
        dialogWidth: 900,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        dialogClickModal: false,
        menu: false,
        selectable: (row, index) => {
          return !this.selectedPoints.some(item => item.sid === row.id);
        },
        // labelPosition: 'top',
        column: [
          // {
          //   label: '',
          //   prop: 'nameOrIds',
          //   search: true,
          //   display: false,
          //   hide: true,
          //   editDisplay: false,
          //   viewDisplay: false,
          //   addDisplay: false,
          //   type: 'search',
          //   span: 24,
          //   placeholder: this.Lang.Text.modelSearchPointIds,
          //   searchSlot: true,
          // },
          {
            label: 'ID',
            prop: 'id',
            search: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
            placeholder: this.Lang.Text.modelSearchPointIds,
            onChange: (e) => {
              this.onLoad(this.page,{id: e.value});
            },
          },
          {
            label: this.Lang.Title.standardPointType,
            prop: 'stype',
            search: false,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=typesOfTelemetering',
            dataType: 'string',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
          },
          {
            label: this.Lang.Title.standardPointPoint,
            prop: 'name',
            search: true,
            onChange: (e) => {
              this.onLoad(this.page,{name: e.value});
            },
          },
          {
            label: this.Lang.Title.standardPointFormat,
            prop: 'datatypeName',
            search: false,
          },
          {
            label: this.Lang.Title.modelUnit,
            prop: 'unit',
            search: false,
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission', 'language']),
    CURRENT_LANGUAGE() {
      return getLanguage(this.language);
    },
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    scopeIds() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    this.search.language = this.language; // 默认当前语言
  },
  methods: {
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    getSelectedPoints() {
      const selectedPoints = this.selectionList;
      return selectedPoints;
    },
    onCancel() {
      this.showAddMeasurementPoint = false;
    },
    // 无用的函数，保留
    rowSave(row, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowUpdate(row, index, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowDel(row) {
      this.$confirm( this.Lang.tips.ifConfirmDelete, 'Delete Measurement Point', {
        content: this.Lang.tips.ifConfirmDelete,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    // 无用的函数，保留
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({id: this.form.id}).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      // 遍历新选择的列表，只有不在 this.selectionList 中的数据才添加
      list.forEach((item) => {
        const exists = this.selectionList.some((selected) => selected.id === item.id);
        if (!exists) {
          this.selectionList.push(item);
        }
      });
      console.log('selectionChange this.selectionList', this.selectionList);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      console.log('sizeChange this.selectionList',this.selectionList)
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
      };
      getPage(page.currentPage, page.pageSize, Object.assign(values, this.query), this.currentLangKey).then(
        res => {
          const data = res.data.data || {};
          this.page.total = data.total || 0;
          this.data = data.records || [];
          this.scopeLoading = false;
          console.log('getPage this.selectionList',this.selectionList)
          // this.selectionClear(); // 跳转第二页保留上次所选
        }
      );
    },
  },
};
</script>
